import { Modal } from 'antd';
import { History } from 'history';
import React from 'react';
import IconClose from '@/assets/images/icons/icon-close.react.svg?react';
import InfoCircleFill from '@/assets/images/icons/info-circle-fill.react.svg?react';
import i18n from '@/i18n';
import { BusiCode } from '@/infrastructure/axios/code';
import style from '@/presentation/components/internal-app-list/style.module.scss';
import { MAIL_MESSAGE, USER_PRODUCT_MAX_LIMIT_MESSAGE } from '@/presentation/config/message';
import { productService } from '@/service/product';
import { userService } from '@/service/user';

export const allowCreateProduct = async (history: History<unknown>): Promise<boolean> => {
  const userInfo = await userService.getUserInfo();
  if (userInfo === null) {
    return false;
  }
  if (!userInfo?.mail) {
    Modal.confirm({
      closable: true,
      icon: <InfoCircleFill/>,
      closeIcon: <IconClose/>,
      className: style.notify,
      title: i18n.t('温馨提示'),
      cancelText: i18n.t('取消'),
      okText: i18n.t('跳转填写'),
      onOk() {
        history.push('/user/profile');
      },
      content: i18n.t(MAIL_MESSAGE),
    });
    return false;
  }
  const allow = await productService.allowCreate({});
  if (allow.baseRsp?.code !== BusiCode.Ok) {
    return false;
  }
  if (allow.allow !== true) {
    Modal.info({
      closable: true,
      closeIcon: <IconClose/>,
      className: style.notify,
      okText: i18n.t('我知道了'),
      content: i18n.t(USER_PRODUCT_MAX_LIMIT_MESSAGE),
    });
    return false;
  }
  return true;
};
